import Loader from "components/Loader/Loader";
import Context from "context/Global";
import React, { useState, useEffect, useContext } from "react";
import toast from "react-hot-toast";
import Api from "services/Api/Api";

const FortnoxAuthenticator = ({ children }) => {
    const context = useContext(Context);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isCheckingAuth, setIsCheckingAuth] = useState(true);

    const checkAuthentication = async () => {
        setIsCheckingAuth(true);
        try {
            const user = await Api.getCurrentUser();
            if (user.role === "OWNER") {
                const response = await Api.validateFortnoxInvoiceToken({
                    brandId: user.brand.id,
                });

                if (response.tokenValid) {
                    setIsAuthenticated(!!response.tokenValid);
                } else {
                    const response = await Api.refreshFortnoxInvoiceToken({
                        brandId: user.brand.id,
                    });
                    setIsAuthenticated(response.tokensRefreshed);
                }
            } else {
                toast.error("Du saknar behörighet för att hantera fakturor.");
                setIsAuthenticated(false);
            }
        } catch (error) {
            setIsAuthenticated(false);
        } finally {
            setIsCheckingAuth(false);
        }
    };

    useEffect(() => {
        checkAuthentication();
    }, []);

    const requestlogin = async (state) => {
        const response = await Api.invoiceLoginRequest();
        const authUrl = response.authUrl + `&state=${state}`;
        window.open(authUrl, "Connect to Fortnox", "width=1000,height=800");
    };

    const handleFortnoxConnect = (event) => {
        event.preventDefault();

        const state = Math.random().toString(36).substring(2);
        requestlogin(state);

        const handleMessage = (event) => {
            if (event.origin !== window.location.origin) {
                return;
            }

            const { type, authCode, returnState } = event.data;

            if (type === "INVOICE_AUTH_CODE") {
                window.removeEventListener("message", handleMessage);
                event.source.close();

                if (returnState !== state || !authCode) {
                    toast.error("Inloggningen misslyckades!");
                } else {
                    const authenticate = async () => {
                        await Api.authorizeFortnoxInvoicing({
                            brandId: context.user.brand.id,
                            authorizationCode: authCode,
                        });

                        checkAuthentication();
                    };

                    authenticate();
                }
            }
        };

        window.addEventListener("message", handleMessage);
    };

    if (isCheckingAuth) {
        return <Loader />;
    }

    if (!isAuthenticated) {
        return (
            <div className="mx-auto p-4">
                <div className="flex flex-col items-start">
                    <h1 className="text-2xl font-bold mb-2">Logga in</h1>
                    <p className="mb-4">
                        Autentisera dig i Fortnox för att kunna hantera
                        fakturering
                    </p>
                    <button
                        className="c-button c-button--raised inline-flex items-center"
                        onClick={(ev) => handleFortnoxConnect(ev)}
                        disabled={context.user.role !== "OWNER"}
                    >
                        <span>LOGGA IN I FORTNOX</span>
                    </button>
                </div>
            </div>
        );
    }

    return children;
};

export default FortnoxAuthenticator;
